<template>
  <div class="app-container">
    <!-- 顶部导航 -->
    <!-- <header class="app-header"> ... </header> -->

    <!-- 主体区域 -->
    <main class="app-main">
      <!-- Tabs -->
      <div class="tab-container">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="border-card">
          <!-- 分组管理 Tab -->
          <el-tab-pane label="分组管理" name="group">
            <div class="pane-content">
              <div class="toolbar">
                <div class="left-actions">
                  <el-button type="primary" size="default" icon="el-icon-plus" @click="openAddDialog('group')">
                    新建分组
                  </el-button>
                  <span class="total-count">共 <strong>{{ groupList.length }}</strong> 个分组</span>
                </div>
                <div class="right-actions">
                  <el-button size="default" icon="el-icon-refresh" @click="loadGroups">刷新</el-button>
                </div>
              </div>
              <div class="table-wrap">
                <el-table
                  v-loading="groupLoading"
                  :data="groupList"
                  stripe
                  border
                  style="width:100%"
                  height="70vh"
                  :row-style="{ height: '56px' }"
                  :cell-style="{ padding: '8px 12px' }"
                >
                  <el-table-column prop="bfenlei4" label="分组名称" min-width="200">
                    <template slot-scope="{ row }">
                      <span class="name-cell">{{ row.bfenlei4 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="bfenlei6" label="备注" min-width="240" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span class="remark-cell">{{ row.bfenlei6 || '—' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="{ row }">
                      <div class="action-group">
                        <el-button type="text" size="default" class="action-btn edit-btn" @click="openEditDialog('group', row)">
                          <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <span class="action-divider">|</span>
                        <el-button type="text" size="default" class="action-btn delete-btn" @click="handleDelete('group', row)">
                          <i class="el-icon-delete"></i> 删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div class="empty-state-custom">
                      <div class="empty-icon-wrap">
                        <i class="el-icon-folder-opened"></i>
                      </div>
                      <div class="empty-title">暂无分组</div>
                      <div class="empty-sub">点击「新建分组」添加您的第一个分组</div>
                      <el-button type="primary" size="small" plain @click="openAddDialog('group')" style="margin-top:16px;">
                        + 立即创建
                      </el-button>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>

          <!-- 标签管理 Tab -->
          <el-tab-pane label="标签管理" name="tag">
            <div class="pane-content">
              <div class="toolbar">
                <div class="left-actions">
                  <el-button type="primary" size="default" icon="el-icon-plus" @click="openAddDialog('tag')">
                    新建标签
                  </el-button>
                  <span class="total-count">共 <strong>{{ tagList.length }}</strong> 个标签</span>
                </div>
                <div class="right-actions">
                  <el-button size="default" icon="el-icon-refresh" @click="loadTags">刷新</el-button>
                </div>
              </div>
              <div class="table-wrap">
                <el-table
                  v-loading="tagLoading"
                  :data="tagList"
                  stripe
                  border
                  style="width:100%"
                  height="70vh"
                  :row-style="{ height: '56px' }"
                  :cell-style="{ padding: '8px 12px' }"
                >
                  <el-table-column prop="bfenlei4" label="标签名称" min-width="180">
                    <template slot-scope="{ row }">
                      <span class="name-cell">{{ row.bfenlei4 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否展示" width="160" align="center">
                    <template slot-scope="{ row }">
                      <div class="display-tag" @click="toggleDisplay(row)">
                        <el-tag
                          :type="row.is_display === '1' ? 'success' : 'info'"
                          size="default"
                          effect="plain"
                          hit
                        >
                          <!-- <span class="tag-icon">{{ row.is_display === '1' ? '✓' : '✕' }}</span> -->
                          {{ row.is_display === '1' ? '展示中' : '已隐藏' }}
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="bfenlei6" label="备注" min-width="220" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span class="remark-cell">{{ row.bfenlei6 || '—' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="{ row }">
                      <div class="action-group">
                        <el-button type="text" size="default" class="action-btn edit-btn" @click="openEditDialog('tag', row)">
                          <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <span class="action-divider">|</span>
                        <el-button type="text" size="default" class="action-btn delete-btn" @click="handleDelete('tag', row)">
                          <i class="el-icon-delete"></i> 删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div class="empty-state-custom">
                      <div class="empty-icon-wrap">
                        <i class="el-icon-price-tag"></i>
                      </div>
                      <div class="empty-title">暂无标签</div>
                      <div class="empty-sub">点击「新建标签」添加您的第一个标签</div>
                      <el-button type="primary" size="small" plain @click="openAddDialog('tag')" style="margin-top:16px;">
                        + 立即创建
                      </el-button>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </main>

    <!-- 新建/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      top="8vh"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="dialog-form"
    >
      <el-form :model="form" label-width="80px" ref="formRef" size="default">
        <el-form-item
          label="名称"
          prop="name"
          :rules="[
            { required: true, message: '请输入名称', trigger: 'blur' },
            { max: 20, message: '最多20个字符', trigger: 'blur' }
          ]"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入名称（最多20字）"
            maxlength="20"
            clearable
            size="default"
          />
          <span class="char-count">{{ form.name.length }}/20</span>
        </el-form-item>

        <!-- 是否展示（仅标签模式显示） -->
        <el-form-item v-if="activeTab === 'tag'" label="是否展示">
          <div class="display-switch-wrap">
            <el-switch
              v-model="form.is_display"
              :active-value="1"
              :inactive-value="0"
              active-color="#1890ff"
              inactive-color="#bfbfbf"
            />
            <span class="switch-label" :class="{ active: form.is_display === '1' }">
              {{ form.is_display === '1' ? '展示' : '隐藏' }}
            </span>
            <span class="switch-tip">开启后，标签将在前端展示</span>
          </div>
        </el-form-item>

        <el-form-item
          label="备注"
          prop="remark"
          :rules="[{ max: 100, message: '最多100个字符', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注（选填，最多100字）"
            maxlength="100"
            show-word-limit
            size="default"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="default" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="default" :loading="saving" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'GroupTagManagement',
  data () {
    return {
      activeTab: 'group',
      shopId: '',
      groupList: [],
      groupLoading: false,
      tagList: [],
      tagLoading: false,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      saving: false,
      form: {
        id: null,
        name: '',
        remark: '',
        is_display: 1
      }
    }
  },

  created () {
    this.shopId = localStorage.getItem('sh_id') || '2'
    this.loadGroups()
    this.loadTags()
  },

  methods: {
    goBack () {
      if (window.history.length > 1) {
        window.history.back()
      } else {
        this.$message.info('已返回')
      }
    },

    handleTabClick () {
      if (this.activeTab === 'group') {
        this.loadGroups()
      } else {
        this.loadTags()
      }
    },

    refreshAll () {
      this.loadGroups()
      this.loadTags()
      this.$message.success('已刷新全部数据')
    },

    // ---------- 分组 API ----------
    async loadGroups () {
      this.groupLoading = true
      try {
        const params = {
          bfenlei1: this.shopId,
          bfenlei2: '201'
        }
        const res = await request.post('/goods/fenzu_jiben_list.php', params)
        if (res && res.code === 0) {
          this.groupList = res.fenzuList || []
        } else {
          this.$message.error(res?.msg || '加载分组失败')
          this.groupList = []
        }
      } catch (err) {
        console.error('加载分组失败:', err)
        this.$message.error('网络错误，请检查连接')
        this.groupList = []
      } finally {
        this.groupLoading = false
      }
    },

    // ---------- 标签 API ----------
    async loadTags () {
      this.tagLoading = true
      try {
        const params = {
          bfenlei1: this.shopId,
          sh_id: this.shopId,
          bfenlei2: '502'
        }
        const res = await request.post('/goods/fenzu_jiben_list.php', params)
        if (res && res.code === 0) {
          let list = res.fenzuList || []
          list = list.map((item) => ({
            ...item,
            is_display: item.is_display !== undefined ? item.is_display : 1
          }))
          this.tagList = list
        } else {
          this.$message.error(res?.msg || '加载标签失败')
          this.tagList = []
        }
      } catch (err) {
        console.error('加载标签失败:', err)
        this.$message.error('网络错误，请检查连接')
        this.tagList = []
      } finally {
        this.tagLoading = false
      }
    },

    // ---------- 弹窗控制 ----------
    openAddDialog (type) {
      this.isEdit = false
      this.form = {
        id: null,
        name: '',
        remark: '',
        is_display: 1
      }
      this.dialogTitle = type === 'group' ? '新建分组' : '新建标签'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    openEditDialog (type, row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        name: row.bfenlei4 || '',
        remark: row.bfenlei6 || '',
        is_display: row.is_display !== undefined ? row.is_display : 1
      }
      this.dialogTitle = type === 'group' ? '编辑分组' : '编辑标签'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    // ---------- 提交表单 ----------
    submitForm () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        if (!this.form.name || !this.form.name.trim()) {
          this.$message.warning('请输入名称')
          return
        }
        this.saving = true
        if (this.isEdit) {
          this.doEdit()
        } else {
          this.doAdd()
        }
      })
    },

    // ----- 新增 -----
    async doAdd () {
      const isTag = this.activeTab === 'tag'
      const params = {
        bfenlei1: this.shopId,
        bfenlei4: this.form.name.trim(),
        bfenlei6: this.form.remark || ''
      }
      params.bfenlei2 = '201'
      if (isTag) {
        params.sh_id = this.shopId
        params.bfenlei2 = '502'
        params.is_display = this.form.is_display
      }
      try {
        const res = await request.post('/goods/fenzu_jiben_add.php', params)
        if (res && res.code === 0) {
          this.$message.success(isTag ? '标签创建成功' : '分组创建成功')
          this.dialogVisible = false
          this.refreshCurrentTab()
        } else {
          this.$message.error(res?.msg || '创建失败')
        }
      } catch (err) {
        console.error('创建失败:', err)
        this.$message.error('网络错误，请重试')
      } finally {
        this.saving = false
      }
    },

    // ----- 编辑 -----
    async doEdit () {
      const isTag = this.activeTab === 'tag'
      const params = {
        id: this.form.id,
        bfenlei4: this.form.name.trim(),
        bfenlei6: this.form.remark || ''
      }
      params.bfenlei2 = '201'
      if (isTag) {
        params.bfenlei2 = '502'
        params.sh_id = this.shopId
        params.is_display = this.form.is_display
      }
      try {
        const res = await request.post('/goods/fenzu_jiben_edit.php', params)
        if (res && res.code === 0) {
          this.$message.success(isTag ? '标签更新成功' : '分组更新成功')
          this.dialogVisible = false
          this.refreshCurrentTab()
        } else {
          this.$message.error(res?.msg || '更新失败')
        }
      } catch (err) {
        console.error('更新失败:', err)
        this.$message.error('网络错误，请重试')
      } finally {
        this.saving = false
      }
    },

    // ---------- 删除 ----------
    async handleDelete (type, row) {
      try {
        await this.$confirm(
          `确定要删除${type === 'group' ? '分组' : '标签'}「${row.bfenlei4 || ''}」吗？`,
          '提示',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        const isTag = type === 'tag'
        const params = { id: row.id }
        if (isTag) {
          params.bfenlei2 = '502'
        }
        const res = await request.post('/include/fenzu_jiben_del.php', params)
        if (res && res.code === 0) {
          this.$message.success(`${type === 'group' ? '分组' : '标签'}已删除`)
          this.refreshCurrentTab()
        } else if (res && res.code === 1) {
          this.$alert(res.msg || '该分组/标签下存在关联数据，无法删除', '提示', { confirmButtonText: '知道了' })
        } else {
          this.$message.error(res?.msg || '删除失败')
        }
      } catch (err) {
        if (err !== 'cancel') {
          console.error('删除失败:', err)
          this.$message.error('网络错误，请重试')
        }
      }
    },

    // ---------- 切换展示状态（仅标签） ----------
    async toggleDisplay (row) {
      const newStatus = row.is_display === 1 ? 0 : 1
      const originalStatus = row.is_display
      row.is_display = newStatus // 乐观更新

      const params = {
        id: row.id,
        bfenlei2: '502',
        sh_id: this.shopId,
        bfenlei4: row.bfenlei4 || '',
        bfenlei6: row.bfenlei6 || '',
        is_display: newStatus
      }
      try {
        const res = await request.post('/goods/fenzu_jiben_edit.php', params)
        if (res && res.code === 0) {
          this.$message.success(newStatus === 1 ? '已设为展示' : '已设为隐藏')
        } else {
          row.is_display = originalStatus
          this.$message.error(res?.msg || '状态更新失败')
        }
      } catch (err) {
        row.is_display = originalStatus
        console.error('切换状态失败:', err)
        this.$message.error('网络错误，请重试')
      }
    },

    // ---------- 刷新当前 Tab ----------
    refreshCurrentTab () {
      if (this.activeTab === 'group') {
        this.loadGroups()
      } else {
        this.loadTags()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/* ===== 全局布局 ===== */
.app-container {
  height: 100vh;
  overflow: auto;
  background: #f0f2f5;
  font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ===== 顶部导航 ===== */
.app-header {
  background: #fff;
  border-bottom: 1px solid #e8ecf1;
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  z-index: 10;

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .back-btn {
      cursor: pointer;
      font-size: 14px;
      color: #555;
      display: flex;
      align-items: center;
      gap: 4px;
      transition: color 0.2s;

      &:hover {
        color: #1890ff;
      }
      .el-icon-arrow-left {
        font-size: 16px;
      }
    }
    .page-title {
      font-size: 18px;
      font-weight: 600;
      color: #1d2129;
      letter-spacing: 0.5px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #86909c;
    font-size: 14px;

    .shop-info {
      background: #f7f8fa;
      padding: 4px 14px;
      border-radius: 12px;
      color: #4e5969;
    }
  }
}

/* ===== 主体区域 ===== */
.app-main {
  flex: 1;
  padding: 20px 24px 24px 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ===== Tabs 容器 ===== */
.tab-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-tabs__header {
    margin: 0;
    padding: 0 24px;
    background: #fafbfc;
    border-bottom: 1px solid #e8ecf1;
    flex-shrink: 0;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    font-size: 15px;
    font-weight: 500;
    color: #4e5969;
    height: 52px;
    line-height: 52px;
    padding: 0 20px;
    transition: all 0.25s;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 3px;
      background: #1890ff;
      border-radius: 2px 2px 0 0;
      transition: width 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);
    }

    &:hover {
      color: #1890ff;
    }
  }
  .el-tabs__item.is-active {
    color: #1890ff;
    font-weight: 600;

    &::after {
      width: 60%;
    }
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__content {
    flex: 1;
    padding: 0;
    overflow: hidden;
  }
  .el-tab-pane {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

/* ===== Pane 内容区域 ===== */
.pane-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 24px 24px 24px;
  height: 100%;
}

/* ===== 工具栏 ===== */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 12px;

  .left-actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .el-button--primary {
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.25);
      transition: all 0.25s;

      &:hover {
        box-shadow: 0 4px 16px rgba(24, 144, 255, 0.35);
        transform: translateY(-1px);
      }
    }
  }
  .right-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    .el-button {
      color: #4e5969;
      &:hover {
        color: #1890ff;
      }
    }
  }
  .total-count {
    font-size: 14px;
    color: #86909c;
    padding: 4px 14px;
    background: #f5f6f8;
    border-radius: 20px;

    strong {
      color: #1d2129;
      font-weight: 600;
      font-size: 16px;
    }
  }
}

/* ===== 表格容器 ===== */
.table-wrap {
  flex: 1;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  border: 1px solid #eaedf2;

  .el-table {
    height: 100%;
    border-radius: 8px;

    .el-table__header-wrapper {
      .el-table__header {
        th {
          background-color: #f7f9fc !important;
          font-weight: 600;
          color: #1d2129;
          font-size: 14px;
          padding: 12px 12px;
          border-bottom: 2px solid #e8ecf1;
        }
      }
    }

     .el-table__body-wrapper {
      overflow-y: auto;

      .el-table__row {
        transition: background 0.2s;

        &:hover {
          background: #f5f9ff !important;
        }
      }
    }

     .el-table__empty-block {
      min-height: 280px;
    }
  }
}

/* ===== 单元格样式 ===== */
.name-cell {
  font-weight: 500;
  color: #1d2129;
  font-size: 14px;
}

.remark-cell {
  color: #86909c;
  font-size: 13px;
}

/* ===== 操作按钮组 ===== */
.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;

  .action-btn {
    padding: 0 8px;
    font-size: 13px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;

    i {
      font-size: 14px;
    }
  }

  .edit-btn {
    color: #1890ff;
    &:hover {
      color: #40a9ff;
    }
  }

  .delete-btn {
    color: #ff4d4f;
    &:hover {
      color: #ff7875;
    }
  }

  .action-divider {
    color: #d9d9d9;
    font-weight: 200;
    margin: 0 2px;
  }
}

/* ===== 展示状态标签 ===== */
.display-tag {
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  display: inline-block;

  .el-tag {
    min-width: 80px;
    text-align: center;
    transition: all 0.25s;
    border-radius: 14px;
    font-weight: 500;
    font-size: 13px;
    padding: 0 16px;
    height: 30px;
    line-height: 28px;

    .tag-icon {
      margin-right: 4px;
    }
  }
  .el-tag--success {
    background: #e6f7e6;
    border-color: #b7eb8f;
    color: #389e0d;
  }
  .el-tag--info {
    background: #f5f5f5;
    border-color: #d9d9d9;
    color: #8c8c8c;
  }
  &:hover .el-tag {
    transform: scale(1.04);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
  }
}

/* ===== 空状态 ===== */
.empty-state-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  .empty-icon-wrap {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    transition: all 0.3s;

    .el-icon-folder-opened,
    .el-icon-price-tag {
      font-size: 40px;
      color: #b7c0cc;
      transition: all 0.3s;
    }
  }

  &:hover .empty-icon-wrap {
    background: #e8f0fe;
    .el-icon-folder-opened,
    .el-icon-price-tag {
      color: #1890ff;
    }
  }

  .empty-title {
    font-size: 17px;
    font-weight: 600;
    color: #1d2129;
    margin-bottom: 4px;
  }

  .empty-sub {
    font-size: 14px;
    color: #b0b8c4;
  }
}

/* ===== 弹窗表单 ===== */
.dialog-form {
   .el-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      padding: 20px 24px 16px 24px;
      border-bottom: 1px solid #f0f2f5;
      background: #fafbfc;

      .el-dialog__title {
        font-size: 17px;
        font-weight: 600;
        color: #1d2129;
      }
    }

    .el-dialog__body {
      padding: 24px 28px 16px 28px;
    }

    .el-dialog__footer {
      padding: 12px 24px 20px 24px;
      border-top: 1px solid #f0f2f5;
      background: #fafbfc;
    }
  }

  .el-form-item {
    margin-bottom: 22px;

    .el-form-item__label {
      font-weight: 500;
      color: #1d2129;
    }
  }

  .char-count {
    position: absolute;
    right: 10px;
    bottom: 8px;
    font-size: 12px;
    color: #c0c4cc;
    pointer-events: none;
    background: #fff;
    padding: 0 4px;
  }

  .el-textarea .el-textarea__inner {
    padding-right: 56px;
  }

  .display-switch-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;

    .switch-label {
      font-size: 14px;
      color: #8c8c8c;
      font-weight: 500;
      transition: color 0.25s;

      &.active {
        color: #1890ff;
      }
    }
    .switch-tip {
      font-size: 12px;
      color: #c0c4cc;
      background: #f5f6f8;
      padding: 2px 12px;
      border-radius: 12px;
    }
  }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 768px) {
  .app-header {
    padding: 0 16px;
    height: 52px;
    .page-title {
      font-size: 16px;
    }
  }
  .app-main {
    padding: 12px 12px 16px 12px;
  }
  .tab-container {
    border-radius: 8px;
    .el-tabs__header {
      padding: 0 12px;
    }
    .el-tabs__item {
      font-size: 14px;
      padding: 0 14px;
      height: 44px;
      line-height: 44px;
    }
  }
  .pane-content {
    padding: 14px 14px 16px 14px;
  }
  .toolbar {
    flex-direction: column;
    align-items: stretch;
    .left-actions,
    .right-actions {
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  .dialog-form  .el-dialog {
    width: 94% !important;
    margin: 0 auto;
  }
}
</style>
